import {
  PASSWORD_PROPERTY,
  CONFIRM_PASSWORD_PROPERTY,
  HIDDEN_PROPERTY
} from './constants'

export default {
  password: {
    name: PASSWORD_PROPERTY,
    type: 'password',
    label: 'Password'
  },

  confirmPassword: {
    name: CONFIRM_PASSWORD_PROPERTY,
    type: 'password',
    label: 'Confirm Password'
  },

  hiddenField: {
    name: HIDDEN_PROPERTY,
    type: 'hidden'
  }
}
